import { useMutation, UseMutationResult } from '@tanstack/react-query';

import MultiChannelApi from '../../../lib/api/multiChannel/multiChannelApi';
import { MultiChannelOrderItemDeliveryTrackingFindResponseDto } from '../../../types/api/multi-channels';

const useMultiChannelDeliveryTracking = (): UseMutationResult<
  MultiChannelOrderItemDeliveryTrackingFindResponseDto,
  unknown,
  number
> => {
  return useMutation((payload: number) => MultiChannelApi.getMultiChannelDeliveryTracking(payload));
};

export default useMultiChannelDeliveryTracking;
